import { createErrorLogger, errorLogger } from '@rfp/utils-shared/ErrorLogging';

export { createErrorLogger, errorLogger };

export const logError = (error: unknown, file: string, method: string): void => {
  void errorLogger(error, false, `Caught from ${file} from the method ${method}`);
};
